import formatStat, { renderStat } from '@utils/formatStat'
import capitalize from '@utils/capitalize'
import { size } from '@styles/theme'

import { DialogFormGroup, Section, SectionHeading } from './SharedFormComponents'
import { SingleEnumRadio } from '@elements/form_elements/SingleEnumRadio'
import { DialogInput } from '@elements/dialog_inputs/DialogInput'

const longLabelStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  flexShrink: 0,
  width: size(20),
  marginRight: size(-4),
}

const PracticesRadioList = ({ state, handleExtendedChange }) => {
  const vals = ['practices_unspecified', 'bareback_only', 'condoms_only', 'safer_only', 'bareback_or_condoms', 'talk_first']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <SingleEnumRadio
          key={i}
          slots={{ label: { style: longLabelStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='practices'
          label={capitalize(formatStat('practices', val)) || 'Unspecified'}
          value={val}
        />
      ))}
    </DialogFormGroup>
  )
}

const HivStatusRadioList = ({ state, handleExtendedChange }) => {
  const vals = ['hiv_status_unspecified', 'negative', 'neg_on_prep', 'positive', 'poz_undetectable', 'unknown', 'prefer_not_to_say']
  return (
    <DialogFormGroup>
      {vals.map((val, i) => (
        <SingleEnumRadio
          key={i}
          slots={{ label: { style: longLabelStyles } }}
          onChange={handleExtendedChange}
          state={state}
          name='hivStatus'
          label={capitalize(formatStat('hivStatus', val)) || 'Unspecified'}
          value={val}
        />
      ))}
    </DialogFormGroup>
  )
}

const HealthFormSection = ({ state, handleExtendedChange, handleClear }) => {
  return (
    <Section style={{ paddingTop: size(2), paddingBottom: size(6) }}>
      <SectionHeading>
        Health & Safety
      </SectionHeading>
      <DialogInput
        label='Practices'
        onClear={() => handleClear('practices', 'practices_unspecified')}
        displayValue={state['practices'] && renderStat('practices', state)}>
        <PracticesRadioList state={state} handleExtendedChange={handleExtendedChange} />
      </DialogInput>
      <DialogInput
        label='HIV Status'
        onClear={() => handleClear('hivStatus', 'hiv_status_unspecified')}
        displayValue={state['hivStatus'] && renderStat('hivStatus', state)}>
        <HivStatusRadioList state={state} handleExtendedChange={handleExtendedChange} />
      </DialogInput>
    </Section>
  )
}

export { HealthFormSection }
